/**
 * Force a file download from a same-origin URL.
 * Uses a temporary anchor so the browser respects the `download` attribute and
 * shows a save dialog instead of navigating (or previewing inline).
 */
export function triggerDownload(href: string, filename: string): void {
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
